import ActionCell from './ActionCellContainer';

export default ActionCell;
